'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'box-taped';
var width = 448;
var height = 512;
var aliases = ["box-alt"];
var unicode = 'f49a';
var svgPathData = ['M16.2 144c-.1 1.5-.2 3-.2 4.5L16 416c0 26.5 21.5 48 48 48l320 0c26.5 0 48-21.5 48-48l0-267.5c0-1.5-.1-3-.2-4.5l-135.8 0 0 72c0 22.1-17.9 40-40 40l-64 0c-22.1 0-40-17.9-40-40l0-72-135.8 0zm4.4-16l133.4 0 27.4-96-68.5 0c-15.5 0-30 7.5-39.1 20.1L24.9 120.6c-1.7 2.3-3.1 4.8-4.3 7.4zm246-96l27.4 96 133.4 0c-1.2-2.6-2.7-5-4.3-7.4L374.1 52.1c-9-12.6-23.6-20.1-39.1-20.1l-68.5 0z', 'M432 416l0-267.5c0-1.5-.1-3-.2-4.5l-135.8 0 0 72c0 22.1-17.9 40-40 40l-64 0c-22.1 0-40-17.9-40-40l0-72-135.8 0c-.1 1.5-.2 3-.2 4.5L16 416c0 26.5 21.5 48 48 48l320 0c26.5 0 48-21.5 48-48zM168 144l0 72c0 13.3 10.7 24 24 24l64 0c13.3 0 24-10.7 24-24l0-72-112 0zm109.4-16l-27.4-96-51.9 0-27.4 96 106.8 0zm16.6 0l133.4 0c-1.2-2.6-2.7-5-4.3-7.4L374.1 52.1c-9-12.6-23.6-20.1-39.1-20.1l-68.5 0 27.4 96zM262 16l73 0c20.7 0 40.1 10 52.1 26.8l48.9 68.5c7.8 10.9 11.9 23.9 11.9 37.2L448 416c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 148.5c0-13.3 4.2-26.3 11.9-37.2L60.9 42.8C72.9 26 92.3 16 112.9 16L262 16zM181.4 32l-68.5 0c-15.5 0-30 7.5-39.1 20.1L24.9 120.6c-1.7 2.3-3.1 4.8-4.3 7.4l133.4 0 27.4-96z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBoxTaped = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;